import {
  UserGroupIcon,
  ClockIcon,
  EyeDropperIcon,
  MagnifyingGlassIcon,
  AcademicCapIcon,
  FaceSmileIcon,
  PhoneIcon,
  PrinterIcon,
  EnvelopeIcon,
  SparklesIcon,
  CloudIcon,
  ArrowDownIcon,
  CogIcon,
  PaintBrushIcon,
  CameraIcon,
  CheckCircleIcon,
  DocumentIcon
} from "@heroicons/react/24/solid";

import benefitOneImg from "../img/benefit-one.png";

// Blend pictures
import blend1 from "../img/manufacture/blend/blend1.jpg";
import blend2 from "../img/manufacture/blend/blend2.jpg";
import blend3 from "../img/manufacture/blend/blend3.jpg";

// Capsule pictures
import capsuling1 from "../img/manufacture/capsule/capsuling1.jpg";
import capsuling2 from "../img/manufacture/capsule/capsuling2.jpg";
import capsuling3 from "../img/manufacture/capsule/capsuling3.jpg";

//Tablet pictures
import tabletting1 from "../img/manufacture/tablet/tabletting1.jpg";
import tabletting2 from "../img/manufacture/tablet/tabletting2.jpg";
import tabletting3 from "../img/manufacture/tablet/tabletting3.jpg";

//Blister pictures
import blister2 from "../img/conditionning/blister/blister2.jpg";
import blister3 from "../img/conditionning/blister/blister3.jpg";

//Pot pictures
import pot1 from "../img/conditionning/pot/pot1.jpg";
import pot2 from "../img/conditionning/pot/pot2.jpg";

//Powder pictures
import powder1 from "../img/conditionning/powder/powder1.jpg";
import powder2 from "../img/conditionning/powder/powder2.jpg";

//Contact
import plan from "../img/plan.jpg";

//NotFound pictures
import notFound1 from "../img/notFound/notFound1.png";
import notFound2 from "../img/notFound/notFound2.png";
import notFound3 from "../img/notFound/notFound3.png";

const dataNL = {
  navigation: [
    {
      href: "/",
      label: "Home",
    },
    {
      href: "/manufacture",
      label: "Productie",
    },
    {
      href: "/conditionning",
      label: "Verpakking",
    },
    {
      href: "/quality",
      label: "Kwaliteit",
    },
    {
      href: "/contact",
      label: "Contact",
    },
  ],
  home: {
    preTitle: "De voordelen van Pharma Manufacturing",
    title: "Expertise & Kwaliteit",
    desc: (
    <>
    Op maat gemaakte productie van voedingssupplementen volgens <span className="text-green-500">GMP</span> normen en <span className="text-green-500">FSSC22000</span> certificering. <br/>
    Farmaceutische expertise sinds <span className="font-bold">1988</span>.<br/>
    Kwaliteit gegarandeerd door professionals, waaronder <span className="font-bold"><span className="text-green-500">3</span> apothekers</span> en <span className="font-bold">state-of-the-art apparatuur.</span>
    </>
    ),
  },
  hero: {
    eyebrow: "Farmaceutische expertise",
    sinceLabel: "Sinds",
    title: "Pharma Manufacturing",
    desc: ( 
      <> 
        Al meer dan 30 jaar dient onze farmaceutische expertise uw welzijn. <br/>State-of-the-art apparatuur voor productie volgens de strengste normen.
      </>
    ),
    subDesc: (
      <>
        Een vloot van <span className="text-green-500">meer dan 50</span> machines om al uw projecten te realiseren.
      </>
    ),
    calloutLabel: "Productie",
    calloutText: "Meer dan 50 machines om al uw projecten te ondersteunen.",
  },
  benefitOne: {
    title: "Expertise",
    desc: "Pharma Manufacturing biedt u de garantie van unieke knowhow. Met tientallen jaren ervaring biedt ons multidisciplinaire team van apothekers en diëtisten gespecialiseerde expertise in de formulering en productie van voedingssupplementen. Van ontwerp tot realisatie, wij begeleiden u in al uw projecten.",
    image: benefitOneImg,
    bullet: true,
    bullets: [
      {
        title: "Multidisciplinair Team",
        desc: "Bestaande uit een industrieel apotheker, apothekers en een diëtist",
        icon: <UserGroupIcon />,
      },
      {
        title: "Bewezen Ervaring",
        desc: "Sinds 1988",
        icon: <ClockIcon />,
      },
      {
        title: "Beheersing van Normen",
        desc: "FSSC2200, BIO",
        icon: <AcademicCapIcon />,
      },
    ],
  },
  manufacture: {
    preTitle: "De Kunst van productie",
    title: "Demande de notification pour compléments alimentaires",
  },
    notification: {
    preTitle: "The Art of Manufacturing",
    title: "Manufacturing",
  },
  blend: {
    title: "Blenden",
    desc: "Met verschillende mengmachines van alle maten, waaronder planetair en tumbler type, garandeert Pharma Manufacturing de homogeniteit van uw mengsels voor zowel kleine als grote hoeveelheden.",
    desc2: "",
    desc3: "",
    images: [blend1, blend2, blend3],
    bullet: false,
    bullets: [
      {
        title: "Zuivere Producten",
        desc: "Zorgvuldige en gecontroleerde productie",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Zuivere Producten",
        desc: "Zorgvuldige en gecontroleerde productie",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Klanttevredenheid",
        desc: "Bewezen efficiëntie en vertrouwen",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  capsule: {
    title: "Capsules",
    desc: "Met 5 capsulemachines van verschillende capaciteiten in de maten 00, 0, 1, kan Pharma Manufacturing zonder probleem elke hoeveelheid vanaf 50.000 capsules produceren.",
    desc2: "",
    images: [capsuling1, capsuling2, capsuling3],
    bullet: true,
    bullets: [
      {
        title: "Polijsten",
        desc: "",
        icon: <SparklesIcon />,
      },
      {
        title: "Stofzuigen",
        desc: "",
        icon: <CloudIcon />,
      },
    ],
  },
  tablet: {
    title: "Tabletten",
    desc: "Met 2 veelzijdige tabletpersen met pre-compressie, kan Pharma Manufacturing tabletten van alle maten tot 23 mm en in alle gewenste vormen produceren, inclusief ronde en pilvormige tabletten, evenals ovale tabletten die tot anderhalf gram werkzame stof kunnen bevatten.",
    desc2:"",
    images: [tabletting1, tabletting2, tabletting3],
    bullet: true,
    bullets: [
      {
        title: "Directe Compressie",
        desc: "Het poeder wordt direct gecomprimeerd na het mengen",
        icon: <ArrowDownIcon />,
      },
      {
        title: "Compressie na Granulatie",
        desc: "Tijdens het mengen worden sommige ingrediënten gegranuleerd voor betere compressie",
        icon: <CogIcon />,
      },
      {
        title: "Coating",
        desc: "Na compressie kunnen we de tabletten coaten",
        icon: <PaintBrushIcon />,
      },
    ],
  },
  conditionning: {
    preTitle: "Altijd een optie voor uw producten",
    title: "Verpakking",
  },
  blister: {
    title: "Blisterverpakking",
    desc: "Uitgerust met 5 blisters en een encartonneermachine, heeft Pharma Manufacturing een hoge dagelijkse capaciteit om u in de kortst mogelijke tijd van producten te voorzien.",
    desc2:"",
    desc3: "",
    images: [blister2, blister3],
    bullet: true,
    bullets: [
      {
        title: "Camera",
        desc: "Een camera inspecteert gebreken en werpt niet-conforme blisters weg",
        icon: <CameraIcon />,
      },
      {
        title: "Automatische Encartonneermachine Controle",
        desc: "De machine voert een automatische controle uit om te verifiëren of het juiste aantal blisters in de doos zit",
        icon: <CheckCircleIcon />,
      },
      {
        title: "Aanwezigheid van Instructieblad",
        desc: "De automatische controle controleert ook of het blad aanwezig is in de doos",
        icon: <DocumentIcon />,
      },
    ],
  },
  powder: {
    title: "Poeders",
    desc: "Verpakking van dieetpoeders in potten of emmers van klein of groot volume.",
    desc2: "",
    desc3: "",
    images: [powder1, powder2],
    bullet: false,
    bullets: [
      {
        title: "Strikte Controle",
        desc: "Naleving van de verschillende gevolgde certificeringen",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Zuivere Producten",
        desc: "Zorgvuldige en gecontroleerde productie",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Klanttevredenheid",
        desc: "Bewezen efficiëntie en vertrouwen",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  pot: {
    title: "Bottelen",
    desc: "Met een optische teller en een etiketteermachine kan Pharma Manufacturing tabletten en capsules van elke grootte bottelen en voorzien van een etiket.",
    desc2: "",
    desc3: "",
    images: [pot1, pot2],
    bullet: false,
    bullets: [
      {
        title: "Strikte Controle",
        desc: "Naleving van de verschillende gevolgde certificeringen",
        icon: <MagnifyingGlassIcon />,
      },
      {
        title: "Zuivere Producten",
        desc: "Zorgvuldige en gecontroleerde productie",
        icon: <EyeDropperIcon />,
      },
      {
        title: "Klanttevredenheid",
        desc: "Bewezen efficiëntie en vertrouwen",
        icon: <FaceSmileIcon />,
      },
    ],
  },
  quality: {
    title: "Kwaliteit",
    desc: "Permanente kwaliteitscontrole door onze industrieel apotheker, onze twee apothekers en hun team:",
    controlList: [
      "Controle en weging van geleverde grondstoffen",
      "Controle van het mengsel en verificatie van het totaalgewicht",
      "Individuele weging van tabletten en capsules tijdens de productie",
      "Hardheids-, desintegratie- en brosheidstests van tabletten",
      "Test van de blisterafdichting",
      "Validatie van de productie door de verantwoordelijke apotheker",
      "Opstellen van productiedossiers volgens GMP (traceerbaarheid van productie- en verpakkingsoperaties)",
      "Naleving van de huidige goede productiemethoden (GMP), evenals HACCP- en FSSC22000-normen",
      "Materiaalstroomprocedures in het productiegebied en naleving van FIFO (first in, first out) tijdens het wegen",
      "Werk beschreven in standaard werkprocedures (SOP)",
      "Koelopslag voor het conserveren van onder andere probiotica vóór en onmiddellijk na de productie om de productkwaliteit te waarborgen",
    ],
  },
  contact: {
    title: "Contact",
    desc: (
      <>
        <span className="text-green-500 font-bold uppercase">
          Pharma Manufacturing
        </span>
        <br></br>
        Créalys Wetenschapspark <br></br>
        Rue Guillaume Fouquet, 16<br></br>
        5032 ISNES
      </>
    ),
    desc2: "",
    desc3: "",
    image: plan,
    imageFrame: false,
    bullets: [
      {
        title: "Telefoon",
        desc: "+ 32 (0) 81/73.55.81",
        icon: <PhoneIcon />,
      },
      {
        title: "Fax",
        desc: "+ 32 (0) 81/73.55.61",
        icon: <PrinterIcon />,
      },
      {
        title: "E-Mail",
        desc: (
          <>
            <a href="mailto:pharma.manufacturing@gmail.com">
              <span className="text-green-500">pharma.manufacturing@gmail.com</span>
            </a>
          </>
        ),
        icon: <EnvelopeIcon />,
      },
    ],
  },
  notFound: {
    title: "Het lijkt erop dat je de deur naar het grote niets hebt gevonden",
    desc: "De inhoud die je zoekt bestaat niet. Of het is verwijderd, of je hebt de link verkeerd getypt.",
    desc2: "Onze excuses hiervoor! Bezoek onze homepage om te komen waar je heen wilt.",
    desc3: "Terug naar de startpagina",
    images: [notFound1, notFound2, notFound3],
    bullet: false,
    bullets: [
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
      {
        title: "",
        desc: "",
        icon: "",
      },
    ],
  },
};


export { dataNL };
